import { useSelector } from 'react-redux';

const Money = ({
  value,
  currency = null,
  symbol = null,
  currencyCode = null,
  convert = true,
  decimal = true,
  lowDecimals = false,
  showSymbol = true,
  symbolSize
}) => {
  const currencies = useSelector((state) => state.currency);
  const currencyToShow = currency ? currency : currencies.selected;

  if (typeof value === 'string') {
    value = parseFloat(value);
  }

  if (value === null || isNaN(value)) return;

  const valueInSelectedCurrency = convert ? value * currencyToShow?.exchangeRate : value;

  if (symbol === null) {
    symbol = currencyToShow?.symbol;
  }

  const integerPart = parseInt(valueInSelectedCurrency.toFixed(2));
  const decimalPart = valueInSelectedCurrency.toFixed(2).slice(-2);

  return (
    <div className={`money ${!decimal ? 'p-0' : ''}`}>
      <div className='integer'>
        {currencyCode !== null ? currencyCode : null}{' '}
        {showSymbol ? (
          <span className='mr-1' style={{fontSize: symbolSize ? symbolSize : 'inherit'}}>
            {symbol}
          </span>
        ) : (
          ''
        )}
        {integerPart.toLocaleString()}
        {lowDecimals ? `.${decimalPart}` : ''}
      </div>
      {decimal ? <span className='moneyCents'>{decimalPart}</span> : ''}
    </div>
  );
};

export default Money;
